import { resolveCatalogPrice } from './priceCatalog.js';
import { resolveCheckoutUpdates } from './subscriptionPlan.js';
import { SIGNAL_MANAGER_PRODUCT } from './config.js';
import { BILLING_CYCLES } from './config.js';

// Flat per-unit package, so quantity is always 1 — the seat count is a display
// label, not a billing multiplier (qty = seats would charge the price per seat).
export function buildSignalManagerCheckoutItems(catalog, options = {}) {
  if (!catalog) return [];
  const price = resolveCatalogPrice(catalog, SIGNAL_MANAGER_PRODUCT, BILLING_CYCLES.monthly, options);
  return price?.id ? [{ price_id: price.id, quantity: 1 }] : [];
}

export function resolveSignalManagerCheckout(catalog) {
  const items = buildSignalManagerCheckoutItems(catalog);
  if (items.length === 0) return null;
  return resolveCheckoutUpdates(items, [], catalog, { usedProductIds: [], skipTrial: true });
}
